import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, Output, SimpleChanges, ViewChild } from '@angular/core';
import { BaseFileHandler } from '../base-file-handler';
import { ProjectService } from '../../../services/project.service';
import { StorageService } from '../../../../Common/services/storage.service';
import { ToastrService } from 'ngx-toastr';
import { RefTypeEnum } from '../../../enums/ref-type-enum';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MessageService } from '../../../services/message.service';
import { DataShareService } from '../../../services/data-share.service';
import { ConfirmationService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { UnsavedChangesService } from '../../../../unsaved-changes.service';
import { Category } from '../../../../administration/models/models-vm';
import { EmailNotificationService } from '../../../../Common/services/email-notification.service';
import { ProjectDto } from '../../../../Common/models/emailrequestdto';
import { ActionItems } from '../../../../Common/Constants/common.constants';
import { ProjectConstants } from '../../../constants/component-messages';

@Component({
  selector: 'app-common-products-list',
  templateUrl: './common-products-list.component.html',
  styleUrl: './common-products-list.component.css'
})
export class CommonProductsListComponent 
  extends BaseFileHandler<Blob, File>
  implements AfterViewInit, OnDestroy{
    
  @Input() categoryId?: string; // Receive vendorId from parent component  
  @Input() selectedCategories : number[]=[];
  @ViewChild('productFileInput') productsFileInput: ElementRef | undefined;
  @Output() productFileSelected = new EventEmitter<any>();
  @Input() reciveCoomunication: any = {};  
  @Input() isProductListChecked: boolean = false;
  @Input() isProductReviewChecked: boolean = false;
  @Input() isProductReviewedDate: Date | null | undefined;
  @Input() selectedCategoryList: Category[] = [];
  @Input() selStoreDetails?: any | null = null;
  //@Input() isProductReviewedBy: string = '';
  // @Input() disableAfterReview: boolean = false;
  @Output() notifyRButtonStatus: EventEmitter<{}> = new EventEmitter<{}>();
  @Output() notifyProductSelections: EventEmitter<{}> = new EventEmitter<{}>();
  @Output() notifyParent: EventEmitter<{}> = new EventEmitter<{}>();
  @Output() notifyReviewConfirmation: EventEmitter<boolean> = new EventEmitter<boolean>();

  disableProductsSection: boolean = false;
  isReviewConfirmed: boolean = false;
  isRadioChecked: boolean = false;
  subscription1: Subscription = new Subscription();
  subscription2: Subscription = new Subscription();

  constructor(projectService: ProjectService,
    storageService: StorageService,
    toastr: ToastrService,
    private ngxService: NgxUiLoaderService,
    private msgService: MessageService,
    private dataShareService:DataShareService,
    private confirmationService:ConfirmationService,
    private unsavedChangesService: UnsavedChangesService,
    private emailService: EmailNotificationService
  ) {
    super(projectService, storageService, toastr);
  }
  onAnyFieldValueChange(e:boolean){
    if(e){
      this.unsavedChangesService.setUnsavedChanges(true);
    }
  }

  ngOnInit()
  {
    // this.notifyParent.emit({
    //   from: "productlist",
    //   action: "uploadproductswithexcel"
    // });
    // this.disableProductsSection = false;
    //this.isProductListChecked = true;

    if(this.selectedFile!=null
      && this.selectedFile!.projectFileID! > 0
    )
    {
      this.fileName = this.selectedFile!.fileName!;
      this.isFileUploaded = true;
    }

    //this.loadDefaultSelection(true);
   
    // ///this is to capture the products upload selection type change.
    // this.dataShareService.dataShareOfProductsSelection.subscribe(result=>{
    //     if(result != null && result.isFrom=="manual"){
    //       if(result.isDataToRemove==false){
    //         this.isProductListChecked=true;
    //         this.disableProductsSection = false;
    //       }else{
    //         this.isProductListChecked=false;
    //         this.disableProductsSection = true;
            
    //        // this is to notify parent so that it can update the object
    //         this.notifyProductSelections.emit(
    //           {from: 'manual', rejected: true});
    //       }
    //     }
    // });

    this.subscription1 = this.dataShareService.switchBetweenProducts.subscribe(result => {
      // Check if there is a result and if the switch is coming from the "list" mode
      if (result != null && result.isFrom === "manualradio") {
        this.isRadioChecked = !result.checked;
      }
    });
    
    this.subscription2 = this.dataShareService.switchBetweenProducts.subscribe(result => {
      // Check if there is a result and if the switch is coming from the "list" mode
      if (result != null && result.isFrom === "manual") {
        

        if (result.action === 'displayDialog') {
          
          // Check if any products are selected (i.e., selectedProductRows is not null, undefined, or empty)
          if (this.selectedFile != null &&
              this.selectedFile !== undefined &&
              this.selectedFile.base64Bytes!.length > 0) 
          {
    
            // Show confirmation dialog to the user
            this.confirmationService.confirm({
              header: "Products Dialog",
              icon: 'pi pi-exclamation-triangle',
              message: "You are about to change the mode of adding Products. " +
                      "If you have added any products, those will be deleted.",
              
              // If the user confirms, proceed with the switch
              accept: () => {
                //this.isProductListChecked=false;
                this.disableProductsSection = true;

                this.dataShareService.emitDataBetweenProducts({
                  "action":'accepted',"isFrom":"list"
                });

              // this is to notify parent so that it can update the object
              this.notifyProductSelections.emit(
                {from: 'manual', rejected: true});
              },
              
              // If the user rejects, keep the current mode and prevent data removal
              reject: () => {
                this.isRadioChecked=true;
                this.dataShareService.emitDataProductRadioChecked({
                  checked: this.isRadioChecked,
                  isFrom: 'listradio'
                });

                //this.isProductListChecked=false;
                this.disableProductsSection = false;

                this.dataShareService.emitDataBetweenProducts({
                  "action":'rejected',"isFrom":"list"
                });
              }
            });
          }
          else
          {
            //this.isProductListChecked=false;
            this.disableProductsSection = true;

            this.dataShareService.emitDataBetweenProducts({
              "action":'accepted',"isFrom":"list"
            });
          }
        }
          
        // If the action is to display the confirmation dialog
        if (result.action === 'rejected') {          
          //this.isProductListChecked=false;
          this.disableProductsSection = true;
        }
        if (result.action === 'accepted') {          
          //this.isProductListChecked=true;
          this.disableProductsSection = false;
        }
      }
    });
  }

  
  ngOnDestroy() {
    // Unsubscribe from all subscriptions
    this.subscription1.unsubscribe();
    this.subscription2.unsubscribe();
  }
  
  loadDefaultSelection(isChecked: boolean)
  {
    this.isRadioChecked=isChecked;
    this.dataShareService.emitDataProductRadioChecked({
      checked: this.isRadioChecked,
      isFrom: 'listradio'
    });

    this.dataShareService.emitDataBetweenProducts({
      "action":'displayDialog',"isFrom":"list"
    });
  }

  ngAfterViewInit(): void {
    this.setFileInput(this.productsFileInput);    
    this.setColumnsForValidation(["ProductID", "CategoryID", "ProductTitle", "UPC", "VendorItemNumber", "ParentID", "IsActive"]);
    this.setDownLoadFileName("ProductsList");
  }

  async ngOnChanges(changes: SimpleChanges) {
    if(this.selectedFile!=null)
      {
        this.fileName = this.selectedFile!.fileName!;
        this.totalCount =
          await this.getRowCountFromBlob(this.base64ToBlob(this.selectedFile!.base64Bytes!, this.contentType));

        if(this.totalCount !=undefined
          && this.totalCount !=null
          && this.totalCount.length > 0
        )
        {
          this.displayTotalCount = "(" + this.totalCount + ")";
        }

        this.isFileUploaded = true;
      }
      else
      {
        this.clearFileDetails();
      }
      
  }
  
  async onFileSelected(event: any): Promise<void> {
    const file = event.target.files[0];

    if (file) {
      const fileExtension = "." + file.name.split('.').pop()?.toLowerCase();

      if(file.size > this.maxSize)
      {
        this.msgService.htmlError('File size cannot exceed 5 MB');
        this.clearFileDetails();
      }
      else if('.xlsx' != fileExtension)
      {
        this.msgService.htmlError('File type not allowed');
        this.clearFileDetails();
      }
      else
      {
        this.fileName = file.name;
        await this.validateExcelFile1(file);

        if(this.totalCount !=undefined
          && this.totalCount !=null
          && this.totalCount.length > 0
        )
        {
          this.displayTotalCount = "(" + this.totalCount + ")";
        }
        // if(this.refType == RefTypeEnum.Project)
        // {
        //   await this.validateExcelFile1(file);
        //   this.displayTotalCount = "(" + this.totalCount + ")";
        // } 
        // else
        // {
        //   await this.validateExcelFile(file);
        //   this.displayTotalCount = "(" + this.totalCount + ")";
        // }
        if(this.productsFileInput){
          this.productsFileInput.nativeElement.value='';
        }
          
        let fileData = {
          file : file,
          totalCount : this.totalCount
        }
        this.unsavedChangesService.setUnsavedChanges(true);
        this.productFileSelected.emit(fileData);
      }
    }
    else{
      this.selectedFile!.fileChanged= false;
      this.productFileSelected.emit(this.selectedFile);
    }
  }

  async downLoadExcelPreview(event: Event) {
    this.ngxService.start();
    event.preventDefault(); // Prevent the default behavior (navigation)
    event.stopPropagation(); // Stop the event from bubbling up

    let blob = this.base64ToBlob(this.selectedFile?.base64Bytes!, this.contentType);
    this.downloadFile(blob);
    this.ngxService.stop();
  }
  
  downloadExcel(event: Event): void {
    event.preventDefault(); // Prevent the default behavior (navigation)
    event.stopPropagation(); // Stop the event from bubbling up

    if(!this.disableAfterReview)
    {
      if(!this.disableProductsSection)
      {
        // if (this.categoryId === undefined
        //   || this.categoryId === '0'
        // ) {
        //   this.msgService.htmlError('Select Category to download products list.');
        //   return;
        // }  

        if (this.selectedCategories.length === 0) {
          this.msgService.htmlError('Select Category to download products list.');
          return;
        }  
        
        this.ngxService.start();
        
        let dLink = this.downloadLink;
        this.downloadLink = "Products.xlsx"
        // this.projectService.downloadProductlList(this.categoryId).subscribe((data) => {
          this.projectService.downloadProductsByCategories(this.selectedCategories).subscribe((data) => {
          //this.downloadBlob = data;
          this.downloadFile(data);
          this.msgService.htmlSuccess('Product Excel file downloaded successfully.');
          this.ngxService.stop();
          this.downloadLink = dLink;
        });
      }    
    }    
  }

  handleRadioChange(event: any) {
    var target = event.target;

    if(target.checked)
    {
      // this.notifyParent.emit({
      //   from: "productlist",
      //   action: "uploadproductswithexcel"
      // });
      // this.disableProductsSection = false;
      // this.isProductListChecked = true;

      // this.notifyRButtonStatus.emit({
      //   from: 'productList',
      //   checked: true
      // });

      this.isRadioChecked=true;
      this.dataShareService.emitDataProductRadioChecked({
        checked: this.isRadioChecked,
        isFrom: 'listradio'
      });

      this.dataShareService.emitDataBetweenProducts({
        "action":'displayDialog',"isFrom":"list"
      });
      
      // this.confirmationService.confirm({
      //   header: "Products Dialog",
      //   icon: 'pi pi-exclamation-triangle',
      //   message: "You are about to change the mode of adding Products. If you have added any products, those will be deleted",
      //   accept: () => {
      //     this.confirmYes();
      //   },
      //   reject: () => {
      //     target.checked=false;
      //     this.dataShareService.emitDataShareOfProductsSelection({"isDataToRemove":false,"isFrom":"list"});
      //   }
      // });

    }
    else
    {
      alert('l');
    }
    // else
    // {
    //   this.disableProductsSection = true;
    //   this.isProductListChecked = false;
    // }
   //console.log('target', target.checked);
  }

  handleReviewConfirmChange(event: any) {
    var target = event.target;
    if (target.checked) {
      // Show confirmation dialog to the user for Product Review
      this.confirmationService.confirm({
        header: "Products Dialog",
        icon: 'pi pi-exclamation-triangle',
        message: "Have you reviewed the product items to ensure they are accurate?",

        accept: () => {
          this.isProductReviewChecked = true;
        },

        reject: () => {
          this.isProductReviewChecked = false;
          target.checked = false;
        }
      });
    }
    else {
      this.isProductReviewChecked = false;
    }

    this.notifyReviewConfirmation.emit(this.isProductReviewChecked);
  }
  // confirmYes(){
  //   this.dataShareService.emitDataShareOfProductsSelection({"isDataToRemove":true,"isFrom":"list"});
  // }

  confirmYes(){

    this.disableProductsSection = false;
    this.isProductListChecked = true;

    // this.notifyRButtonStatus.emit({
    //   from: 'productList',
    //   checked: true
    // });

    this.dataShareService.emitDataShareOfProductsSelection({"isDataToRemove":true,"isFrom":"list"});
  }
  
  showReminderDialog() {

    if (this.refType == RefTypeEnum.Project && this.selStoreDetails.projectDetails.projectId > 0) {

      const project: ProjectDto = {
        projectID: this.selStoreDetails.projectDetails.projectId,
        vendorID: Number(this.selStoreDetails.projectDetails.vendorId),
        projectTitle: this.selStoreDetails.projectDetails.projectTitle,
        projectType: this.selStoreDetails.projectDetails.type,
        actionItem: ActionItems.PRODUCTS,
        userID: this.selStoreDetails.projectDetails.ctRequester
      };

      this.emailService.open(this.selectedCategoryList, project);
    }
    else if(this.refType == RefTypeEnum.Sales && this.selStoreDetails.salesplanDetails.salesplanId > 0) {
      
      const project: ProjectDto = {
        projectID: this.selStoreDetails.salesplanDetails.salesplanId,
        vendorID:  this.selStoreDetails.salesplanDetails.vendorId,
        projectTitle: this.selStoreDetails.salesplanDetails.projectTitle,
        projectType: this.refType,
        actionItem: ActionItems.PRODUCTS,
        userID: this.selStoreDetails.salesplanDetails.ctRequester
      };

      this.emailService.open(this.selectedCategories, project);
    }
    else{
      this.msgService.htmlError(ProjectConstants.VALIDATION_REMINDER_EMAIL);
    }
  }

}